var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.classesImage,style:({
    objectPosition: `${_vm.focalPoint.x * 100}% ${_vm.focalPoint.y * 100}%`,
  }),attrs:{"src":_vm.image,"srcset":_vm.srcsetWebp,"sizes":_vm.sizes,"alt":_vm.title,"title":_vm.title,"loading":_vm.loading,"decoding":"async"}})
}
var staticRenderFns = []

export { render, staticRenderFns }